import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Subject, tap, takeUntil } from 'rxjs';
import { UserService } from '../../services/user.service';
import { autoCompleteRequired } from '../../validators/autocompleteRequired';

@Component({
  selector: 'app-users-multiselect-dropdown',
  templateUrl: './users-multiselect-dropdown.component.html',
  styleUrl: './users-multiselect-dropdown.component.scss'
})
export class UsersMultiselectDropdownComponent {

  _unsubscribe$: Subject<boolean> = new Subject()
  @Input() selectedValues: any = []
  form = this.fb.group({
    user_id: ['', [Validators.required,autoCompleteRequired()]],
  })

  @Input() label:string = "Common.UserId"
  @Output() addToList: EventEmitter<any> = new EventEmitter();
  @Output() addToListPhone: EventEmitter<any> = new EventEmitter();

  dataSource:any[] = []
  timeOut:any=0

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.getUsers()
  }

  /*----------------------Functions Called from parent---------------------- */
  // setValue(data){
  //   // console.log("eventdata",data)
  //   this.userVal = `[${data.Service_Id}] - ${data.Service_Id}`;
  // }

  reset(){
    this.form.reset()
    this.selectedValues = []
    this.addToList.emit([])
    this.addToListPhone.emit([])
  }

  /*----------------------Getting Users for dropdown select---------------------- */

  onType(value: string) {
    if (value.length == 0 || value.length > 1) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.dataSource=[]
        this.getUsers(value)
      }, 1000)
    }
  }

  getUsers(searchValue:string='') {
    let body = {
      pageNo:1,
      pageSize: 100,
      isPaginated: false,
      searchString:searchValue
    }
     this.userService.GetUsers(body)
     .pipe(
      tap(
        (result) => {
          let customResult:any[]= []
          if(result.IsSuccess && result.Data.users){
            result.Data.users.map((i: any) => {
              customResult.push({
                _id: i.Id,
                name: `[${i.PhoneNumber}] - ${i.UserFullName}`,
                phone: i.PhoneNumber,
                // photo: ''
              })
            });
            this.dataSource = [...customResult]

          }
        }
      ),
      takeUntil(this._unsubscribe$),
    )
    .subscribe();
  }

  isSelected(data: any) {
    return this.selectedValues.findIndex((x: any) => x.Id == data.Id) > -1
  }

  /*----------------------when Choosing User---------------------- */
  selectItem($event: any) {
    this.selectedValues = $event
    let itemsIds = this.selectedValues.map((i:any)=>i._id)
    let itemsPhones = this.selectedValues.map((i:any)=>i.phone)
    this.addToList.emit(itemsIds)
    this.addToListPhone.emit(itemsPhones)
  }


  ngOnDestroy(): void {
    this._unsubscribe$.next(true)
    this._unsubscribe$.complete()
  }
}
